import React, { Component } from 'react';
import { Image as OriginImage } from '@tinper/next-ui';

class Image extends Component {
    render() {
        return <OriginImage {...this.props} />;
    }
}

export default Image;